/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


    if ($('.helpful-resources .placeholder-svg').length) {
      $('.helpful-resources').hide();
  }

  /** full ingredients modal **/

  $('a.cta').click(function(e) {  
      $('.modaloverlay').addClass('target')
  });
  
  $('.modaloverlay .close').click(function(e) {  
      $('.modaloverlay').removeClass('target')
  });
  
  /** hide featured post if metafields aren't present **/
  
  if ($('.template-product .brick__block__text__inner h2').length == 0) {   
    $('.template-product .brick__section').hide();
  }

  if ($('.helpful-resources:visible').length > 0) {
    $('.template-product .brick__section').hide();
  }

  let bundleVariants = $('.radio__button, .swatch__button');

  $('.bundle-product').each(function() {
    let bundleVariantSelect = $(this).find('select');
    if (bundleVariantSelect) {
      bundleVariantSelect.on('change', function() {
        let title = $(this).find('option:selected').text();
        title = title.replace(/(\r\n|\n|\r)/gm, "").trim();
        bundleVariants.each(function() {
          let variantText = $(this).text().replace(/(\r\n|\n|\r)/gm, "").trim();
          if (variantText.indexOf(title) > -1) {
            $(this).find('input').trigger('click');
          }
        });

        let newLinePropertyText = '';
        $('.bundle-product').each(function(i) {
          let productText = $(this).find('.bundle-product-title .variant-product').text().replace(/(\r\n|\n|\r)/gm, "").trim();
          newLinePropertyText += productText + ' ';
          let option = $(this).find('.bundle-variant-options option:selected').text().replace(/(\r\n|\n|\r)/gm, "").trim();
          if (option) {
            newLinePropertyText += ' - ' + option;
            if (i < $('.bundle-product').length - 1) {
              newLinePropertyText += ', ';
            }
          }
        }); 
        $('#included-in-bundle').val(newLinePropertyText)
      });
    }
  });

  let swatchButtons = $('.product__selectors label');
  swatchButtons.each(function() {
    $(this).on('click', function() {
      if ($(this).parent().find('input').hasClass('sold-out')) {
        $('.klaviyo-bis-trigger').removeClass('klaviyo-bis-trigger--hidden');
      } else {
        $('.klaviyo-bis-trigger').addClass('klaviyo-bis-trigger--hidden');
      }
    });
  });


  // hide 4 oz seabuckthorn in Skincare Starter Set product

  $("#skincare-starter-set .seabuckthorn-cleansing-oil-select .skincare-starter-set-4oz").remove();


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
